import React from 'react';
import './Preloader.scss';

const logo = '/images/logo.png';

const Preloader: React.FC = () => {
  return (
    <div className="flex w-full flex-col items-center justify-center">
      <div className="preloader">
        <div className="spinner"></div>
        <img src={logo} alt="Logo" className="preloader-logo" />
      </div>
    </div>
  );
};

export default Preloader;
